// extracted by mini-css-extract-plugin
export default {"guide":"_1xf0Ip4c7udAh-RdN1zg05"};